import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CreateArena from "@/pages/CreateArena";
import ArenaDashboard from "@/pages/ArenaDashboard";
import PlayerArena from "@/pages/PlayerArena";
import GameMaster from "@/pages/GameMaster";
import BigScreen from "@/pages/BigScreen";
import PlatformAdmin from "@/pages/PlatformAdmin";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/dashboard/create" element={<Protected><CreateArena /></Protected>} />
      <Route path="/arena/:slug" element={<Protected><ArenaDashboard /></Protected>} />
      <Route path="/admin" element={<Protected admin><PlatformAdmin /></Protected>} />
      <Route path="/e/:slug" element={<PlayerArena />} />
      <Route path="/mod/:slug" element={<GameMaster />} />
      <Route path="/display/:slug" element={<BigScreen />} />
      <Route path="/display/:slug/:zoneId" element={<BigScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
